import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { Character, CharacterAbility, CharacterSpell, CreatureInstance, StoredSpell, SummonInstance, SummonOption2 } from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DandDAPI from '../../utilities/system_api';

import LoadingBox from "@components/input/LoadingBox";
import CreatureInstanceInput from "@dndComponents/creature/CreatureInstanceInput";
// import CreatureInstanceInputOld from "@dndComponents/creature/CreatureInstanceInputOld";

interface Props {
  character?: Character;
  obj: SummonOption2;
  spell: CharacterAbility | CharacterSpell | StoredSpell;
  level: number;
  display_variant?: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();
// const api = DandDAPI.getInstance();

export default function DisplaySummonOption({
  obj,
  spell,
  level,
  character
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ci, setCI] = useState<SummonInstance | CreatureInstance>(new CreatureInstance());

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      if (character) {
        setLoading(true);
        // debugger;
        const upgrades = character.summon_upgrade_features.filter(o => 
          o.creature_types.includes(obj.creature_type)
        );
        char_util.createMinion(character, spell, level, obj, upgrades).then(new_ci => {
          if (new_ci instanceof SummonInstance || new_ci instanceof CreatureInstance) {
            setCI(new_ci);
            setLoading(false);
          }
        });
      }
      // if (obj.creature) {
      //   const new_ci = new CreatureInstance();
      // } else if (obj.custom_stat_block) {

      // }
    }
  });

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          { obj.name }
        </Grid>
        <Grid size={12}>
          <CreatureInstanceInput
            character={character}
            creature_instance={ci}
            true_id={ci.true_id}
            view_only
          />
        </Grid>
      </Grid>
    );
  }
}
